module.exports = __webpack_public_path__ + "img/06.afdf62e1.png";